import { Injectable } from '@angular/core';

import * as xlsx from 'xlsx-js-style';
import * as FileSaver from 'file-saver';


@Injectable()
export class ExportExcelService {

    exportJsonExcel(heading: any[], headerWidths: any[], jsonData: any, fileName: string, merge: any[], styles: any[]) {
      const workbook = this.generateJsonExcelWorkbook(heading, headerWidths, jsonData, merge, styles);
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, fileName);
    }

    private generateJsonExcelWorkbook(heading: any[], headerWidths: any[], jsonData: any, merge: any[], styles: any[]) {

      //adding dummy rows because while adding header these rows will be overwritten,
      //so if we don't have dummy rows then actual data will be overwritten, so adding dummy rows in starting point of array
      for(let i = 0; i < heading.length-1; i++) {
          jsonData.unshift({});
      }

      let worksheet = xlsx.utils.json_to_sheet(jsonData);

      worksheet = xlsx.utils.sheet_add_aoa(worksheet, heading);

      worksheet['!cols'] = headerWidths;
      //deleting not required columns
      const range = xlsx.utils.decode_range(worksheet['!ref']);
      range.e['c'] = heading[0].length - 1;
      worksheet['!ref'] = xlsx.utils.encode_range(range);

      if(merge) {
        worksheet["!merges"] = merge;
      }
      if(styles) {
        for(let i = 0; i < styles.length; i++) {
            let obj = styles[i];
            if(worksheet[obj.place]) {
              worksheet[obj.place].s= obj.value;
            }
        }
      }
      worksheet['E1'].s= { font: { sz: 50  } }
      return { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }


}
